// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__cFadx","noInteraction":"EventWrapper_noInteraction__2UFpY"};